module.exports = __webpack_public_path__ + "static/img/sec1-slide-img02.48f8e30.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec1-slide-img02.png
// module id = hluF
// module chunks = 0